import { render, staticRenderFns } from "./BankReportDetailsTable.vue?vue&type=template&id=3277b1a1&"
import script from "./BankReportDetailsTable.vue?vue&type=script&lang=js&"
export * from "./BankReportDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports